/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconTent = createReactComponent("tent", "IconTent", [
  ["path", { d: "M11 14l4 6h6l-9 -16l-9 16h6l4 -6", key: "svg-0" }]
]);

export { IconTent as default };
//# sourceMappingURL=IconTent.js.map
